import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, NgZone} from '@angular/core';
import {GoogleMap} from '@angular/google-maps';
import {AppComponent} from '../app.component';
import {Batiment} from '../Models/Batiment';
import {AnalyticsService} from "../services/analytics.service";

@Component({
	selector: 'app-choix-renov',
	templateUrl: './choix-renov.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./choix-renov.component.less']
})

export class ChoixRenovComponent implements OnInit {

	@ViewChild('search') searchElementRef!: ElementRef;
	@ViewChild(GoogleMap) map!: GoogleMap;
	showFirstStep: boolean = false;
	textes: any = "";
	globalTxt: any = "";
	//utilisateur: any;
	autocomplete: any;
	//adresse: any;
	adresseComplete?: string = "";
	batiment: Batiment = new Batiment();
	showErr: boolean = false;

	constructor(
		public app: AppComponent,
		private ngZone: NgZone,
		private analyticsService: AnalyticsService
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	// GET USER BY ID
	//getUsrByID() {
	//  this.app.apiToolsService.getUserID().subscribe(
	//    (res: any) => {
	//      console.log("res----", res);
	//      if (res) {
	//        this.utilisateur = res;
	//        localStorage.setItem('SIMULATION', JSON.stringify(this.utilisateur));
	//      }
	//    }, err => {
	//      console.log('ERR*---->', err);
	//    }
	//  )
	//}

	ngAfterViewInit(): void {
		setTimeout(() => {
			if (!this.searchElementRef) return;

			let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);

			// let autocomplete = new google.maps.places.Autocomplete(
			// 	this.searchElementRef.nativeElement,
			// 	{
			// 		types: ['postal_code'], // Restrict to postal codes
			// 		componentRestrictions: {country: 'FR'} // Optional: Restrict to a specific country
			// 	}
			// );

			autocomplete.addListener("place_changed", () => {
				this.ngZone.run(() => {
					let place: google.maps.places.PlaceResult = autocomplete.getPlace();
					if (place.geometry === undefined || place.geometry === null) {
						return;
					}
					// console.log('place ------> ', place);
					// this.adresse = place.formatted_address
					// console.log("ADRESSE-----", this.adresse);
					this.adresseComplete = place.formatted_address;
					console.log("this.adresseComplete-----", this.adresseComplete);

					// let numRue = this.formatAdrComp('street_number', place.address_components);
					// let rue = this.formatAdrComp('route', place.address_components);
					//this.batiment.adress = numRue + ' ' + rue;
					let numRue = this.formatAdrComp('street_number', place.address_components) || '';
					let rue = this.formatAdrComp('route', place.address_components) || '';
					this.batiment.adress = (numRue && rue) ? numRue + ' ' + rue : numRue + rue;
					this.batiment.cp = this.formatAdrComp('postal_code', place.address_components);
					this.batiment.ville = this.formatAdrComp('locality', place.address_components);
					console.log("this.batiment ==> ", this.batiment);

					this.showErr = (this.batiment.adress == '');
					// this.showErr = (this.batiment.cp == '');

				})
			})
		}, 3000);
	}

	//Formatage de l'adresse
	formatAdrComp(_param: string, adrListParams: any) {
		let objParam = adrListParams.filter((item: any) =>
			item.types[0] === _param
		);
		//console.log('objParam ------->', objParam);
		return (objParam.length > 0) ? objParam[0].long_name : null;
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			let batimentStorage = JSON.parse(localStorage.getItem("BATIMENT")!);
			if (batimentStorage && batimentStorage.ville) {
				this.batiment = batimentStorage;
				this.adresseComplete = batimentStorage.adress + ', ' + batimentStorage.cp + ' ' + batimentStorage.ville;
			}
			//this.searchElementRef.nativeElement = "2 rue des écoles, 75005 Paris, France";

			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;

					// Get current bien
					this.app.dataToolsService.currentBien.subscribe(currentBien => {
						console.log("currentBien ==> ", currentBien);
						let bien: any = currentBien;
						this.showFirstStep = (!bien.adresse) ? true : false;
					});
				});
		});
	}

	goToTypeRenovation(opt: any) {
		console.log("options----", opt);
		console.log("this.batiment ==> ", this.batiment);

		this.showErr = (this.batiment.adress == '');

		if (this.batiment.adress != '') {
			console.log("erreur de saisie → ", this.showErr);
			this.batiment.typeRenovation = opt.label;

			// Tracking Analytics: Adresse
			this.analyticsService.trackEvent('user_interaction', 'click_adresse', 'value : ' + this.batiment.cp);

			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
			let optPath = this.app.sharedToolsService.getRoutePath(opt.path);
			this.app.router.navigate([optPath]);
		}
		// else {
		// 	this.showErr = true;
		// }
	}

}
